import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface PriceBreakAggregationChangeDialogProps {
  /** Whether the dialog is open */
  open: boolean;
  /** Called when the user cancels the save */
  onCancel: () => void;
  /** Called when the user confirms the save */
  onConfirm: () => void;
}

/**
 * Confirms saving a change to how quotes combine quantities for price list
 * breaks, which reprices existing draft quotes.
 * @param props - PriceBreakAggregationChangeDialogProps
 * @returns Confirmation dialog element
 */
export function PriceBreakAggregationChangeDialog({
  open,
  onCancel,
  onConfirm,
}: PriceBreakAggregationChangeDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent className="max-w-[calc(100%-2rem)] sm:max-w-lg">
        <AlertDialogHeader>
          <AlertDialogTitle>Reprice draft quotes?</AlertDialogTitle>
          <AlertDialogDescription>
            Changing how quantities are combined for price list breaks updates
            the prices on all existing draft quotes. Finalized quotes keep their
            prices.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col-reverse sm:flex-row gap-2">
          <AlertDialogCancel className="mt-0">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Save anyway</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
